import { Drawer } from "@material-ui/core";
import React from "react";
import { doctorBaseUrl } from "../../Util/API Calls/APIList";

const DoctorPostShare = ({ open, onClose, endmeeting, appointment }) => {
  let doctoriframeurl = `${doctorBaseUrl}create-post?doctorId="${appointment.doctor_id}"&patientId="${appointment.patient_id}"`;
  return (
    <>
      <Drawer anchor={"right"} open={open} onClose={onClose} variant="persistent">
        <div className="pt-4 pb-2 previous-patients-prescription-edit-drawer px-0 px-md-2">
          <div className="px-4">
            <span style={{ fontSize: "25px" }}>Share Content</span>{" "}
            {/* <span
              className="float-right cursor-pointer"
              // onClick={this.toggleDrawer.bind(this)}
              style={{ fontSize: "1rem" }}
            >
              Close <i className="fa fa-times" aria-hidden="true"></i>
            </span> */}
            <p style={{ fontSize: "16px" }}>
              Would you like to share any Patient education content with your
              patient?
            </p>
          </div>

          <iframe
            className="knowledge-frame-div"
            frameBorder="0"
            src={encodeURI(doctoriframeurl)}
            title="Knowledge Center"
            style={{ height: "22.25rem" }}
          ></iframe>
        </div>
        <div className="text-center">
          <button
            type="button"
            className="btn rounded-pill "
            style={{
              backgroundColor: "#17BAE0",
              width: "180px",
              color: "white",
            }}
            onClick={() => endmeeting()}
          >
            Continue
          </button>
        </div>
      </Drawer>
    </>
  );
};
export default DoctorPostShare;
